module.exports = __webpack_public_path__ + "img/frame (126).04cc0532.jpg";